<div class="dynamic-select-container">
  <nb-spinner *ngIf="carregando" size="small"></nb-spinner>
  <ng-select
    *ngIf="!carregando"
    [items]="opcoesFormulario"
    bindLabel="textoMostrado"
    bindValue="codigo"
    [placeholder]="valorNaoReconhecido ? mensagemValorNaoReconhecido : placeholder"
    [disabled]="desabilitado"
    [(ngModel)]="valorSelecionadoInterno"
    [multiple]="multiple"
    [closeOnSelect]="!multiple"
    [searchable]="true"
    [clearable]="true"
    [class.full-width]="larguraCompleta"
    [class.size-small]="tamanho === 'small'"
    [class.size-medium]="tamanho === 'medium'"
    [class.size-large]="tamanho === 'large'"
    [class.status-danger]="valorNaoReconhecido"
    [class.status-primary]="!valorNaoReconhecido && status === 'primary'"
    [nbTooltip]="valorNaoReconhecido ? mensagemValorNaoReconhecido : ''"
    [nbTooltipDisabled]="!valorNaoReconhecido"
    [nbTooltipStatus]="valorNaoReconhecido ? 'danger' : undefined"
    [nbTooltipPlacement]="valorNaoReconhecido ? 'top' : undefined"
    [appendTo]="appendTo">
  </ng-select>
</div> 

